import { Card, CardContent, CardHeader, Divider, Grid, Typography } from "@material-ui/core";
import React from "react";
import { userRendererStyles } from "./useRendererStyles";
export const ErrorTile = ({ tile }) => {
    const classes = userRendererStyles();
    return (React.createElement(Grid, { item: true, xs: 12, md: 4 },
        React.createElement(Card, { className: classes.root },
            React.createElement(CardHeader, { title: React.createElement(Typography, { variant: "body1", className: classes.cardHeading }, tile.title), className: classes.header }),
            React.createElement(Divider, null),
            React.createElement(CardContent, null,
                React.createElement(Grid, { container: true },
                    React.createElement(Typography, { variant: "body1" }, getMessageText(tile.type)))))));
};
const getMessageText = (tileType) => {
    switch (tileType) {
        case "Ofqual.ListTile":
        case "Ofqual.CaseListTile":
            return "No data to display";
        default:
            return "Failed to retrieve data";
    }
};
